import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async (dealerId: number) => {
    const { data } = await ApiService.getCampaignCPMValues(dealerId);
    return data;
};

const useCampaignCPMValueListQuery = (dealerId: number) => {
    return useQuery({
        queryKey: ['campaignCPMValueList', dealerId],
        queryFn: () => fetchData(dealerId),
        enabled: dealerId > 0,
    });
};

export { useCampaignCPMValueListQuery };
